<template>
    <product_extra_input
        :cur_idx="cur_idx"
        :items="items"
        cur_type="allergens"
        @change="on_set"
    >

    </product_extra_input>
</template>


<script>
import Info_field from "../../../../sys/info_field.vue";
import Product_extra_input from "./product_extra_input.vue";

export default {
    name: "product_allergens",
    components: {Product_extra_input, Info_field},
    props : {
        cur_idx : {
            type : Number,
            required : true
        },
        items : {
            type : Array,
        }
    },

    methods : {
        on_set(items,type) {
            this.$emit('change_extra',items,type);
        }
    }
}
</script>



<style scoped>
.list-style-none {
    padding-left: 0;
    margin-left: 0;
    list-style: none;
}
</style>
